import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { PrimaryButton } from "Components/Button";
import Link from "Components/Utilities/Link";
import MailLink from "Components/Utilities/MailLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

export default class Conact extends React.Component {
    render () {
        return (
            <Authenticated title="Contact">
                 <div className="relative -mt-6 text-white">
                    <div
                        className="w-full bg-app-light-blue top-0 p-5 absolute left-0 right-0 ml-auto mr-auto"
                        style={ { width: '100vw', left: '50%', transform: 'translateX(-50%)' } }
                    >
                        <div className={"w-full mx-auto text-center mt-6 mb-2"}>
                            <FontAwesomeIcon icon={faQuestionCircle} size={"2x"} className={"text-white text-6xl mx-auto text-center"} />
                        </div>

                        <h1 className={ "text-center text-white font-bold text-2xl mb-6" }>
                            Contact
                        </h1>

                        <p className={ "text-white my-6 text-xl text-center" }>
                            Your registration is required by 30th September, after this time the registration site
                            will be closed.
                        </p>

                        <p className={ "text-white my-6 text-xl text-center max-w-7xl mx-auto" }>
                            If you have any questions in the meantime or require any technical
                            support, please do not hesitate to ask and email
                            { " " }
                            <a href={ "mailto:healthcaresymposium@bupa.com" }
                               className={ "underline cursor-pointer" }
                            >
                                healthcaresymposium@bupa.com
                            </a>
                            { " " }
                        </p>
                    </div>
                </div>
            </Authenticated>
        );
    }
}
